import { render } from "./key-people.vue?vue&type=template&id=1b5d23ff&lang=pug"
import script from "./key-people.vue?vue&type=script&lang=js"
export * from "./key-people.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__